import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import SmartLink from "../fragments/SmartLink";
import Image from "../fragments/Image";
import { useReveal } from '../hooks/UseReveal';

import "swiper/css";
import "swiper/css/navigation";

import Thumbnail from "../fragments/Thumbnail";
import SpecialText from "../fragments/SpecialText";

export default function WhatWeDo({ block }) {

	const swiperRef = useRef(null);
	const revealRef = useReveal({ once: true });

	if (!block || !block.slides || block.slides.length === 0) return null;

	return (
		<div id={block.section_id} className="c-page__block c-page__block--what-we-do scope-reverse c-transition-in" ref={revealRef}>
			<div className="c-what-we-do" >
				<div className="l-grid">
					<div className="l-grid__col">
						<h2 className="c-what-we-do__heading c-heading l-bottom-space">
							<SpecialText text={block.heading || 'What We Do'} />
						</h2>
					</div>
				</div>
				<div className="c-what-we-do__hr" />
				<div className="l-grid">
					<div className="l-grid__col">
						<Swiper
							modules={[Navigation]}
							navigation={true}
							slidesPerView={1}
							spaceBetween={0}
							breakpoints={{
								640: {
									slidesPerView: 2,
								},
								1280: {
									slidesPerView: 3,
								},
								1440: {
									slidesPerView: 4,
								},
							}}
							grabCursor={true}
							onSwiper={(s) => (swiperRef.current = s)}
							className="c-what-we-do__swiper"
						>
							{block.slides.map((slide, index) => {
								return (
									<SwiperSlide key={index}>
										<div className="c-what-we-do__slide">
											<div className="c-what-we-do__slide__inner">
												{slide.heading && (
													<h3 className="c-what-we-do__slide__heading c-paragraph c-paragraph--medium l-bottom-space" dangerouslySetInnerHTML={{ __html: slide.heading }} />
												)}
												{slide.text && (
													<div className="c-what-we-do__slide__text scope-text" dangerouslySetInnerHTML={{ __html: slide.text }} />
												)}
											</div>
										</div>
									</SwiperSlide>
								);
							})}
						</Swiper>
					</div>
				</div>
			</div>
		</div>
	);
} 